import { Stepper } from "@progress/kendo-react-layout";
import "./stepper.scss"; 

// interface to declare all our prop types
interface Props {
    items?:{ label: string, icon: string }[],
    value?: number
    onChange?:any
}

const StepperDefault: React.FC<Props> = ({
  children,
  items = [],
  onChange,
  value = 0,
  ...rest
}) => {
  return (

    <Stepper items={items} onChange={onChange} className="stepper-default" value={value}/> 
  );
};

export default StepperDefault;


